/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";

import { Chip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { useListContext } from "react-admin";

const useStyles = makeStyles((theme) => ({
  chip: {
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
}));

export const QuickMultiFilter = ({ label, defaultValue = {} }) => {
  const { filterValues = {}, setFilters } = useListContext();
  const classes = useStyles();

  // Defensive: ensure filterValues and defaultValue are objects
  const isActive = useMemo(() => {
    if (
      !filterValues ||
      typeof filterValues !== "object" ||
      typeof defaultValue !== "object"
    )
      return false;

    return Object.entries(defaultValue).every(
      ([key, val]) => JSON.stringify(filterValues[key]) === JSON.stringify(val)
    );
  }, [filterValues, defaultValue]);

  const handleClick = () => {
    if (isActive) {
      const newFilters = { ...filterValues };
      Object.keys(defaultValue).forEach((key) => {
        delete newFilters[key];
      });
      setFilters(newFilters, {});
    } else {
      setFilters({ ...filterValues, ...defaultValue }, {});
    }
  };

  return (
    <Chip
      className={classes.chip}
      label={label}
      color="default"
      onClick={handleClick}
      clickable={false}
    />
  );
};
